import styled from 'styled-components';

export const QuestionCardWrapper = styled.div`
  margin-left: ${(props) => props.level * 24}px;
  margin-bottom: 0.5rem;
`;

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9fafb;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const QuestionType = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background-color: #f3f4f6;
  border-radius: 4px;
  color: #4b5563;
  font-weight: 500;
`;

export const QuestionTitle = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  color: #1f2937;
  font-weight: 500;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const IconButton = styled.button`
  padding: 0.25rem;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f3f4f6;
    color: #4b5563;
  }
`;

export const QuestionContent = styled.div`
  padding: 1rem;
  margin-left: 1.5rem;
  border-left: 2px solid #e5e7eb;
  margin-top: 0.5rem;
`;

export const AnswerSection = styled.div`
  margin-bottom: 1rem;
`;

export const MCQSection = styled.div`
  margin-bottom: 1rem;
`;

export const Label = styled.div`
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
`;

export const AnswerText = styled.div`
  color: #1f2937;
  padding: 0.75rem;
  background-color: #f9fafb;
  border-radius: 4px;
  font-size: 0.9rem;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background-color: ${(props) => (props.isCorrect ? '#f0fdf4' : '#f9fafb')};
  border-radius: 4px;
  border: 1px solid ${(props) => (props.isCorrect ? '#86efac' : '#e5e7eb')};
`;

export const OptionNumber = styled.span`
  font-weight: 500;
  color: #6b7280;
  margin-right: 0.75rem;
  font-size: 0.9rem;
`;

export const OptionText = styled.span`
  color: #1f2937;
  font-size: 0.9rem;
`;

export const CorrectBadge = styled.span`
  background-color: #22c55e;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  margin-left: auto;
`;

export const SubQuestionsWrapper = styled.div`
  margin-left: 1.5rem;
  border-left: 2px solid #e5e7eb;
  padding-left: 0.5rem;
  margin-top: 0.5rem;
`;
